import styled from '@emotion/styled';
import { fromTheme } from '@kyruus/ui-theme';

export const ProviderDrawerContainer = styled.div`
  position: relative;
  padding: ${fromTheme('spacing_large')};
  & > .loading-overlay {
    position: absolute;
  }
  & > .loading-overlay .spinner-container {
    position: fixed;
    top: 50%;
    left: 30vw;
  }
`;

export const ProviderDrawerContentWrapper = styled.div`
  max-height: calc(100vh - 100px); // minus height of close/btn container
  overflow-y: auto;
`;
